import * as React from 'react';
import { showModalCreateFolder } from '../../actions';
import { useDispatch } from 'react-redux';
import { AddButton } from '../../components/AddButton';
import { jsx as _jsx } from "react/jsx-runtime";
export function CreateFolderButtonContainer(_ref) {
  var showIcon = _ref.showIcon;
  var dispatch = useDispatch();
  return /*#__PURE__*/_jsx(AddButton, {
    text: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0443",
    showIcon: showIcon,
    onClick: function onClick() {
      return dispatch(showModalCreateFolder());
    }
  });
}